export class MirrorQueryLoopFormField implements plaudit.queryLoop.QueryLoopFormField {
	private primaryField: plaudit.queryLoop.QueryLoopFormField;

	public constructor(private readonly fields: [plaudit.queryLoop.QueryLoopFormField, ...plaudit.queryLoop.QueryLoopFormField[]]) {
		for (let i = 0; i < fields.length && fields.length > 1; i++) {
			if (document.body.contains(fields[i].field)) {
				this.attachFieldInterceptors(fields[i]);
			} else {
				fields.splice(i--, 1);
			}
		}
		this.primaryField = fields[0];
	}
	
	public addField(field: plaudit.queryLoop.QueryLoopFormField) {
		for (let i = 0; i < this.fields.length; i++) {
			if (!this.fields[i].isInDOM()) {
				this.fields.splice(i--, 1);
			}
		}
		this.fields.push(field);
		this.attachFieldInterceptors(field);
	}

	private attachFieldInterceptors(field: plaudit.queryLoop.QueryLoopFormField) {
		const listener = () => {
			this.primaryField = field;
			this.syncFromPrimary();
		};
		field.field.addEventListener('input', listener);
		field.field.addEventListener('change', listener);
	}
	private syncFromPrimary() {
		const value = this.primaryField.getValue();
		for (const field of this.fields) {
			if (field !== this.primaryField) {
				field.setValue(value);
			}
		}
	}

	public isInDOM() {
		for (let i = 0; i < this.fields.length; i++) {
			if (!this.fields[i].isInDOM()) {
				this.fields.splice(i--, 1);
			}
		}
		return this.fields.length > 0;
	}
	public detach() {
		for (const field of this.fields) {
			field.detach();
		}
	}

	get field(): HTMLElement {
		return this.primaryField.field;
	}
	get name(): string {
		return this.primaryField.name;
	}
	get type(): string {
		return this.primaryField.type;
	}

	public getLabel(): string {
		return this.primaryField.getLabel();
	}

	public getLabeledValues(selectedOnly?: boolean): plaudit.queryLoop.LabeledValue[] {
		return this.primaryField.getLabeledValues(selectedOnly);
	}

	public getValue(): string|string[] {
		return this.primaryField.getValue();
	}

	public hasVisibleValue(): boolean {
		return this.primaryField.hasVisibleValue();
	}

	public isTrackedInQuery(): boolean {
		return this.primaryField.isTrackedInQuery();
	}

	public isSetToDefaultValue(): boolean {
		return this.fields.reduce((a, b) => a && b.isSetToDefaultValue(), true);
	}

	public isValueEqual(value: string|string[]): boolean {
		return this.primaryField.isValueEqual(value);
	}

	public loadFromQuery(params: URLSearchParams): boolean {
		return this.fields.reduce((a, b) => b.loadFromQuery(params) || a, false);
	}

	public loadIntoQuery(params: URLSearchParams): boolean {
		return this.fields.reduce((a, b) => b.loadIntoQuery(params) || a, false);
	}

	public remove(value: string): boolean {
		return this.fields.reduce((a, b) => b.remove(value) || a, false);
	}

	public reset(): boolean {
		return this.fields.reduce((a, b) => b.reset() || a, false);
	}

	public setValue(value: string | string[]): boolean {
		return this.fields.reduce((a, b) => b.setValue(value) || a, false);
	}
}
